import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

function QuestionDescription({ question, pageNum, timer }) {
  return (
    <div className="question-panel">
      <div className="panel-content pb-0">
        <div className="topic text-grey-4 d-flex">
          {/* <div className="topic-title font-weight-bold px-3">
              {question?.question_detail &&
                question.question_detail?.topic_name}
            </div> */}
          <div className="question p-3 border text-center mr-3 font-weight-medium rounded-lg ">
            <p className="py-auto mb-0">
              {question?.question_detail && question.question_detail?.question}
              {"    "}
              <span className="fs-smallest rounded-lg p-3">
                (
                {question?.question_detail &&
                  question.question_detail?.time_to_answer}{" "}
                mins)
              </span>
            </p>
          </div>
          {/* <div className="d-flex align-items-center justify-content-between mt-2">
         
          </div> */}
          {question?.question_detail &&<span
            className="fs-smallest rounded-lg p-3"
            style={{
              backgroundColor:
                (question?.question_detail &&
                  question.question_detail?.time_to_answer * 60 - timer) > 30
                  ? "#E1F0DA"
                  : "#FFEBE6",
            }}
          >
            <FontAwesomeIcon
              icon={faClock}
              className="mr-1"
              color={
                (question?.question_detail &&
                  question.question_detail?.time_to_answer * 60 - timer) > 30
                  ? "#294B29"
                  : "#D24545"
              }
            />
            {`${Math.floor(
                  ((question?.question_detail &&
                    question.question_detail?.time_to_answer * 60) -
                    timer) /
                    60
                )}:${
                  ((question?.question_detail &&
                    question.question_detail?.time_to_answer * 60) -
                    timer) %
                  60
                }`}

            {/* {question?.question_detail &&
              question.question_detail?.time_to_answer}{" "} */}
          </span>}
        </div>
      </div>
    </div>
  );
}

export default QuestionDescription;
